const buildSoundUrl = (path) => {
  const value = String(path || '').trim();
  if (!value) return '';

  if (
    value.startsWith('http://') ||
    value.startsWith('https://') ||
    value.startsWith('data:') ||
    value.startsWith('blob:')
  ) {
    return value;
  }

  const normalizedPath = value.replace(/^\/+/, '');
  const publicBase = process.env.PUBLIC_URL ? process.env.PUBLIC_URL.replace(/\/$/, '') : '';
  const originBase = typeof window !== 'undefined' && window.location?.origin ? window.location.origin : '';
  const base = publicBase || originBase;

  if (!base) {
    return `/${normalizedPath}`;
  }

  return encodeURI(`${base}/${normalizedPath}`);
};

export default buildSoundUrl;